import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Share20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Share20Regular";
import { IClientGroupShareGroup } from "../../../src/taskpane/services/clientGroupShareGroups";
import { canShareWithGroup } from "./shareWithGroupEligibility";

/**
 * "Share with group": accountancy tenants only, on a library of a site in a client group (a group,
 * or a member of one; the caller resolves its groups once per directory), for a selection of files.
 */
export function useMenuItem_ShareWithGroup(selectedItems: any[], shareGroups: IClientGroupShareGroup[] | undefined, openShareWithGroupPanel: () => void) {
  const languageStrings = React.useContext(LanguageContext);
  const clientListUrl = useSelector((state: RootState) => state.tenantInfo?.clientListUrl);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.at(-1));

  const menuItem_ShareWithGroup = React.useMemo(() => {
    if (!canShareWithGroup({ currentDirectory, clientListUrl, groupCount: shareGroups?.length ?? 0, selectedItems })) {
      return null;
    }
    return {
      key: "shareWithGroup",
      iconProps: {},
      onRenderIcon: () => <Share20Regular className={menuItemIconStyles} />,
      text: languageStrings.ShareWithGroup,
      onClick: () => openShareWithGroupPanel(),
    } as IContextualMenuItem;
  }, [currentDirectory, clientListUrl, shareGroups, selectedItems, languageStrings, openShareWithGroupPanel]);

  return {
    menuItem_ShareWithGroup
  };
}
